import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * File SVG Icon for upload document button.
 */
export const File: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    aria-hidden={true}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3531 4.51094C13.4469 4.60469 13.5 4.73125 13.5 4.86406V14.5C13.5 14.7766 13.2766 15 13 15H3C2.72344 15 2.5 14.7766 2.5 14.5V1.5C2.5 1.22344 2.72344 1 3 1H9.63594C9.76875 1 9.89688 1.05313 9.99063 1.14688L13.3531 4.51094ZM12.3469 5.09375L9.40625 2.15313V5.09375H12.3469Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
